import { create } from 'zustand'

interface IDialogsStore {
  dialogs: any[];
  setDialog: (dialog: any) => void;
  removeDialog: (dialogKey: any) => void;
  closeDialog: (dialogKey: any) => void;
}

const useDialogsStore = create<IDialogsStore>()(
  set => ({
    dialogs: [],
    setDialog: (dialog: any) => {
      set(state => {
        if (state.dialogs.find(d => d.key === dialog.key)) {
          return state
        }
        return { dialogs: [...state.dialogs, dialog] }
      })
    },
    removeDialog: (dialogKey: any) => {
      set(state => ({ dialogs: state.dialogs.filter(dialog => dialog.key !== dialogKey) }))
    },
    closeDialog: (dialogKey: any) => {
      set(state => ({ dialogs: state.dialogs.map(dialog => {
        if (dialog.key === dialogKey) {
          dialog.isOpen = false
        }
        return dialog
      }) }))
    }
  })
)

export default useDialogsStore
